export const IMPLICIT_DEADLINE_MS = 1800

export const IMPLICIT_ATTRIBUTE_LABELS = {
  1: 'Kolay / basit',
  2: 'Anlaşılır / net',
  3: 'Rahatlatıcı / güvenli',
  4: 'Keyifli / çekici',
  5: 'İkna edici',
  6: 'Güvenilir',
  7: 'Yenilikçi / modern',
  8: 'Bana uygun / ilgili',
  9: 'Motive edici',
  10: 'Yeni bakış açısı',
  11: 'Farklı / ayırt edici',
  12: 'Benzersiz / özgün',
}

export const IMPLICIT_ATTITUDE_STATEMENTS = [
  'Το συγκεκριμένο σενάριο με πείθει ότι η Eurobank έχει κάνει πολύ απλή τη διαδικασία απόκτησης στεγαστικού δανείου.',
  'Το συγκεκριμένο σενάριο με κάνει να αισθάνομαι ανακούφιση ότι πλέον το να πάρω στεγαστικό δάνειο δεν έχει χρονοβόρες και πολύπλοκες διαδικασίες.',
  'Το συγκεκριμένο σενάριο με κάνει να νιώθω ανακούφιση ότι έχω πάντα έναν ειδικό δίπλα μου όποτε τον χρειαστώ.',
  'Η δυνατότητα να πάρω στεγαστικό δάνειο από τη Eurobank με αίτηση από το κινητό με κάνει να θέλω να απευθυνθώ σε αυτήν για το στεγαστικό μου δάνειο.',
  'Παρά όσα παρουσιάζει το συγκεκριμένο σενάριο, η διαδικασία απόκτησης στεγαστικού δανείου εξακολουθεί να μου φαίνεται αγχωτική.',
  'Το συγκεκριμένο σενάριο δεν καταφέρνει να με καθησυχάσει ότι μια τόσο σημαντική διαδικασία μπορεί να γίνει με ασφάλεια χωρίς να χρειάζεται να βρίσκομαι σε κατάστημα της τράπεζας.',
  'Η δυνατότητα να κάνω την αίτηση και να ολοκληρώσω τη διαδικασία απόκτησης του στεγαστικού μου δανείου όποια στιγμή θέλω και από όπου θέλω με εξυπηρετεί και με απαλλάσσει από άγχος.',
]

export function implicitTestRuns(response) {
  const runs = Array.isArray(response.advertisement_tests) ? response.advertisement_tests : []
  if (runs.length) return runs
  if (response.post_ad_questionnaire) {
    return [{
      advertisement_id: response.advertisement_order?.[0] || 'legacy_advertisement',
      trials: response.trials || [],
      questionnaire: response.post_ad_questionnaire,
    }]
  }
  return []
}

function average(values) {
  return values.length ? Math.round(values.reduce((sum, value) => sum + value, 0) / values.length) : null
}

function median(values) {
  if (!values.length) return null
  const ordered = [...values].sort((left, right) => left - right)
  const middle = Math.floor(ordered.length / 2)
  return Math.round(ordered.length % 2 ? ordered[middle] : (ordered[middle - 1] + ordered[middle]) / 2)
}

export function isValidImplicitTrial(trial) {
  if (trial?.rt_ms === null || trial?.rt_ms === undefined || trial?.rt_ms === '') return false
  const rt = Number(trial?.rt_ms)
  return Boolean(trial?.response) && Number.isFinite(rt) && trial?.timed_out !== true && rt <= IMPLICIT_DEADLINE_MS
}

export function reactionStats(trials) {
  const source = Array.isArray(trials) ? trials : []
  const answered = source.filter((trial) => trial?.response)
  const numeric = answered.filter((trial) => trial.rt_ms !== null && trial.rt_ms !== undefined && trial.rt_ms !== '' && Number.isFinite(Number(trial.rt_ms)))
  const valid = numeric.filter(isValidImplicitTrial)
  const matches = answered.filter((trial) => trial.response === 'matches')
  const validMatches = valid.filter((trial) => trial.response === 'matches')
  const numericRt = numeric.map((trial) => Number(trial.rt_ms))
  const validRt = valid.map((trial) => Number(trial.rt_ms))

  return {
    trialCount: source.length,
    answeredCount: answered.length,
    validCount: valid.length,
    timedOutCount: Math.max(0, answered.length - valid.length),
    averageRt: average(numericRt),
    validAverageRt: average(validRt),
    medianRt: median(validRt),
    matchesCount: matches.length,
    validMatchesCount: validMatches.length,
    matchesPercent: answered.length ? Math.round((matches.length / answered.length) * 100) : null,
    validMatchesPercent: valid.length ? Math.round((validMatches.length / valid.length) * 100) : null,
    onTimePercent: answered.length ? Math.round((valid.length / answered.length) * 100) : null,
  }
}

export function combinedReactionStats(runs) {
  return reactionStats((Array.isArray(runs) ? runs : []).flatMap((run) => Array.isArray(run.trials) ? run.trials : []))
}

export function attributeReactionStats(trials) {
  const groups = (Array.isArray(trials) ? trials : []).reduce((result, trial) => {
    const key = Number(trial.attributeIndex) || 0
    result[key] = [...(result[key] || []), trial]
    return result
  }, {})
  return Object.entries(groups).sort(([left], [right]) => Number(left) - Number(right)).map(([attributeIndex, attributeTrials]) => ({
    attributeIndex: Number(attributeIndex),
    attributeLabel: IMPLICIT_ATTRIBUTE_LABELS[attributeIndex] || `Özellik ${attributeIndex}`,
    stimuli: attributeTrials.map((trial) => trial.stimulus).filter(Boolean).join(' · '),
    ...reactionStats(attributeTrials),
    matchCount: attributeTrials.filter((trial) => trial.response === 'matches').length,
    doesNotMatchCount: attributeTrials.filter((trial) => trial.response === 'does_not_match').length,
    missingCount: attributeTrials.filter((trial) => !trial.response).length,
  }))
}

export function advertisementLabel(id) {
  return id === 'h_apokalipsi' ? 'H-APOKALIPSI' : id === 'to_plakaki' ? 'TO-PLAKAKI' : id || '—'
}
